import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useSearchParams } from "react-router-dom";
import { confirmPasswordReset } from "../../api";
import AuthPageBackground from "../Shared/AuthPageBackground/AuthPageBackground";
import "../LogIn/LogIn.css";

const MIN_PASSWORD_LENGTH = 8;

// KHAN-86/KHAN-101: pantalla para confirmar el restablecimiento de
// contraseña con el código recibido por correo. Si el correo llega a
// incluir el código como parámetro ?token=, se precarga automáticamente.
function ResetPassword() {
  const [searchParams] = useSearchParams();
  const [token, setToken] = useState(searchParams.get("token") || "");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const isFilled = token && newPassword && confirmNewPassword;

  const handleSubmit = (event) => {
    event.preventDefault();
    setError("");

    if (newPassword.length < MIN_PASSWORD_LENGTH) {
      setError(`Password must be at least ${MIN_PASSWORD_LENGTH} characters long.`);
      return;
    }

    if (newPassword !== confirmNewPassword) {
      setError("Passwords do not match.");
      return;
    }

    setIsSubmitting(true);
    confirmPasswordReset(token, newPassword)
      .then(() => {
        setSuccess(true);
      })
      .catch((e) => {
        setError(
          e.response?.data?.error || "Invalid or expired reset code. Please request a new one."
        );
      })
      .finally(() => setIsSubmitting(false));
  };

  if (success) {
    return (
      <AuthPageBackground>
        <div className="login-form">
          <div className="login-form-body">
            <div className="login-form-content">
              <h1 className="login-form-title">Password updated</h1>
              <h5 className="login-form-subtitle">
                Your password was changed successfully. You can now log in with it.
              </h5>
              <Button className="login-form-button-filled" onClick={() => navigate("/")}>
                Go to Log In
              </Button>
            </div>
          </div>
        </div>
      </AuthPageBackground>
    );
  }

  return (
    <AuthPageBackground>
      <div className="login-form">
        <div className="login-form-body">
          <Form onSubmit={handleSubmit} className="login-form-content">
            <h1 className="login-form-title">Reset your password</h1>
            <h5 className="login-form-subtitle">
              Enter the code we emailed you and choose a new password.
            </h5>
            <div className="login-form-inputs">
              <Form.Group className="form-group">
                <Form.Label className="font-size">
                  <FontAwesomeIcon className="login-icons" icon={faLock} />
                  Reset code
                </Form.Label>
                <Form.Control
                  size="lg"
                  type="text"
                  value={token}
                  onChange={(e) => setToken(e.target.value)}
                  className="login-form-control-lg"
                  placeholder="Paste the code from your email"
                  required
                />
              </Form.Group>
              <Form.Group className="form-group">
                <Form.Label className="font-size">
                  <FontAwesomeIcon className="login-icons" icon={faLock} />
                  New password
                </Form.Label>
                <Form.Control
                  size="lg"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="login-form-control-lg"
                  placeholder="New password"
                  required
                />
              </Form.Group>
              <Form.Group className="form-group">
                <Form.Label className="font-size">
                  <FontAwesomeIcon className="login-icons" icon={faLock} />
                  Confirm new password
                </Form.Label>
                <Form.Control
                  size="lg"
                  type="password"
                  value={confirmNewPassword}
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                  className="login-form-control-lg"
                  placeholder="Confirm new password"
                  required
                />
              </Form.Group>
              {error && <div className="font-error">{error}</div>}
              <Button
                type="submit"
                disabled={isSubmitting}
                className={isFilled ? "login-form-button-filled" : "login-form-button-empty"}
              >
                Reset password
              </Button>
            </div>
          </Form>
          <div style={{ marginTop: 16, textAlign: "center" }}>
            <span
              className="font-size"
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={() => navigate("/")}
            >
              Back to Log In
            </span>
          </div>
        </div>
      </div>
    </AuthPageBackground>
  );
}

export default ResetPassword;
